import { useCallback, useRef } from 'react';
import { useValueRef } from '@alltrails/core';
import { useAppDispatch, useAppSelector } from '../../../redux';
import { setIsSmartRouting } from '../../../redux/customRoute';

const useOverrideSmartRouting = () => {
  const dispatch = useAppDispatch();
  const isSmartRouting = useAppSelector(state => state.customRoute.isSmartRouting);

  // Sync isSmartRouting state to a ref to prevent re-registering event handlers when the value changes
  const isSmartRoutingRef = useValueRef(isSmartRouting);
  const isOverrideRef = useRef(false);

  const override = useCallback(() => {
    if (isSmartRoutingRef.current) {
      isOverrideRef.current = true;
      dispatch(setIsSmartRouting(false));
    }
  }, [isSmartRoutingRef, dispatch]);

  const restore = useCallback(() => {
    if (isOverrideRef.current) {
      dispatch(setIsSmartRouting(true));
      isOverrideRef.current = false;
    }
  }, [dispatch]);

  return {
    isSmartRoutingRef,
    override,
    restore
  };
};

export default useOverrideSmartRouting;
